// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__qK09l","panda":"NotFound_panda__JpaZD"};